import { Grid, Hidden, Tab, Tabs } from '@paintscout/ui'
import React, { useEffect, useState } from 'react'
import { setUrlQuery } from 'shared/util/routing'
import { useLocation } from 'react-router-dom'
import { ShowWeekendsSwitch } from '../../common/CalendarToolbar'
import Calendar, { CalendarProvider } from '../../common/Calendar'

export default function EventsView() {
  const [tab, setTab] = useState<'calendar' | 'map' | 'schedule'>('calendar')
  const location = useLocation()

  useEffect(() => {
    if (location.pathname.includes('map')) {
      setTab('map')
    } else {
      setTab('calendar')
    }
  }, [location.pathname])

  return (
    <CalendarProvider tab={tab}>
      <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
        <Grid item>
          <Tabs
            value={tab}
            onChange={(_, value) => {
              if (value === 'map') {
                location.pathname = '/events/?tab=map'
              } else if (value === 'calendar') {
                location.pathname = '/events/?tab=calendar'
              }
              setUrlQuery({
                location,
                replaceParams: true,
                params: {
                  search: null,
                  filter: null
                }
              })
            }}
          >
            <Tab label="Calendar" value="calendar" onClick={() => setTab('calendar')} />
            <Tab label="Map" value="map" onClick={() => setTab('map')} />
          </Tabs>
        </Grid>

        <Hidden xsDown>
          {tab === 'calendar' && (
            <Grid item xs container justifyContent="flex-end">
              <ShowWeekendsSwitch />
            </Grid>
          )}
        </Hidden>

        <Grid item xs={12}>
          {(tab === 'calendar' || tab === 'map') && <Calendar />}
          {tab === 'schedule' && <div>Schedule</div>}
        </Grid>
      </Grid>
    </CalendarProvider>
  )
}
